// extracted by mini-css-extract-plugin
var _1 = "FormHeader-moduleFormHeader__rvnWy";
export { _1 as "FormHeader" }
